import React, { useState } from "react";
import { useSelector } from "react-redux";
import Paginator, { Loading } from "@/components/Paginator";
import { Select } from "@/components/Form";

import {
  TransacaoListItem,
  StatusBadge,
  Label,
  Div
} from "./styles";

export default function Transacoes() {
  const { data: user } = useSelector(state => state.auth);
  const [transacoes, setTransacoes] = useState([]);
  const [query, setQuery] = useState({ filters: "todos" });
  const [Default, setDefault] = useState("todos");
  const [paginator, setPaginator] = useState(null);
  const [loadingTransacoes, setLoadingTransacoes] = useState(false);

  const Options = [
    { id: "todos", title: "Todas as transações" },
    { id: "INITIATED", title: "Processando" },
    { id: "COMPLETED", title: "Concluídas" },
    { id: "CANCELED", title: "Canceladas" },
    { id: "REFUNDED", title: "Reembolsadas" },
  ];

  function handleOnFetchComplete(data) {
    setTransacoes(data.data);
    setPaginator(data.paginator);
  }

  function handleChangeFilter(e) {
    const filterValue = e.target.value;
    if (filterValue === "todos") {
      setQuery({});
    } else {
      setQuery({ status: filterValue });
    }
  }

  function formatCurrency(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value / 100);
  }

  function formatDate(dateString) {
    return new Date(dateString).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  function getStatusColor(status) {
    switch (status) {
      case 'INITIATED': return '#f39c12';
      case 'COMPLETED': return '#3498db';
      case 'REFUNDED': return '#27ae60';
      case 'CANCELED': return '#e74c3c';
      default: return '#95a5a6';
    }
  }

  function getStatusText(status) {
    switch (status) {
      case 'INITIATED': return 'Processando';
      case 'COMPLETED': return 'Concluída';
      case 'REFUNDED': return 'Reembolsada';
      case 'CANCELED': return 'Cancelada';
      default: return status;
    }
  }

  function getCategoryText(category) {
    switch (category) {
      case 'PAYROLL': return 'Pagamento';
      default: return category || 'Não informado';
    }
  }

  function renderTransacoes() {
    if (paginator && paginator.total === 0) {
      return <Label>Você não possui nenhuma transação</Label>;
    }

    if (transacoes.length > 0) {
      return transacoes.map(transacao => (
        <TransacaoListItem key={transacao.id}>
          <div className="coluna coluna-descricao">
            <h4>{getCategoryText(transacao.category)}</h4>
            <h5>{transacao.description}</h5>
          </div>
          <div className="coluna coluna-valor">
            <h4>Valor</h4>
            <h5>{formatCurrency(transacao.amount)}</h5>
          </div>
          <div className="coluna coluna-data">
            <h4>Data</h4>
            <h5>{formatDate(transacao.created_at)}</h5>
          </div>
          <div className="coluna coluna-status">
            <h4>Status</h4>
            <StatusBadge color={getStatusColor(transacao.status)}>
              {getStatusText(transacao.status)}
            </StatusBadge>
          </div>
        </TransacaoListItem>
      ));
    }

    return <></>;
  }

  return (
    <Loading loading={loadingTransacoes}>
      <Div>
        <Select
          name="filtro-transacoes"
          label="Filtro das Transações"
          options={Options}
          onChange={e => {
            handleChangeFilter(e);
            setDefault(e.target.value);
          }}
          value={Default}
        />
        <div className="colunasub">
          <h3>{transacoes.length}</h3>
        </div>
      </Div>
      <span>
        <br />
      </span>
      {renderTransacoes()}
      <Paginator
        endpoint={`alunos/${user.perfil_id}/transacoes`}
        query={query}
        onFetchComplete={handleOnFetchComplete}
        onLoading={loading => setLoadingTransacoes(loading)}
      />
    </Loading>
  );
}
